var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyFat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C10 0 0 12.623 0 18.0912C0 23.5594 4.48093 28 10 28C15.5191 28 20 23.5545 20 18.0912C20 12.6279 10 0 10 0ZM10 25.5084C9.85469 25.5039 9.71686 25.4435 9.61569 25.3401C9.51451 25.2366 9.45794 25.0982 9.45794 24.9542C9.45794 24.8101 9.51451 24.6717 9.61569 24.5683C9.71686 24.4648 9.85469 24.4044 10 24.3999C13.9908 24.3999 17.2432 21.1772 17.2432 17.2227C17.2478 17.0788 17.3087 16.9422 17.4131 16.8419C17.5175 16.7417 17.6572 16.6856 17.8026 16.6856C17.948 16.6856 18.0876 16.7417 18.192 16.8419C18.2964 16.9422 18.3574 17.0788 18.3619 17.2227C18.3851 21.8001 14.6195 25.5084 10 25.5084Z",
    fill: "#FFD738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyFat);
export default __webpack_public_path__ + "static/media/BodyFat.69e48097ba5a903a41ef78b29e1476ee.svg";
export { ForwardRef as ReactComponent };